// PwappyPointStore.js
import { configureStore } from '@reduxjs/toolkit';
import pwappyPointReducer from './PwappyPointSlice'; 

const pwappyPointStore = configureStore({
  reducer: {
    pwappyPoint: pwappyPointReducer, 
  },
});

export default pwappyPointStore;